import styled from "@emotion/styled";

export default function Image2() {
  return <RootWrapperImage2 />;
}

const RootWrapperImage2 = styled.div`
  width: 867px;
  height: 664px;
  background: url(https://s3-alpha-sig.figma.com/img/1e30/282d/1594681c9f278e49707110343f4597b4?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Lu-PIBrXL3VaTg9JHtbMU~65F3M7dgmf12S5RwOyxdxnamH-YqKKl3837kbeyUjy-Ke4lSrYzVY3D40djqUvMwBRtfnS-f65LH4OQDu9eDu8LAkuYqkzOIlwbull7UGoLXwf~cyJBzUrI-TsIV9wWYrA68VZAsw2JYGU6LitecGCXqiuqZJ1FB6crCiDwP9LCeaN1lqbLxSb~rZ1AjP2IsN4F9M9pqcoNOz61r0Xy5DPDzKq0ljLdR1hFLb6q6qMW6yu41clEfOhWEdyCP0OXI3jdfgJYaBgLLJey-7HdEqMeGCLyQF5wLxCzJgdAfnU8yKlQKjhZsW5dhSdYSjOig__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
